import { LightBulbIcon } from "@heroicons/react/24/solid";
import { cn } from "helpers/classNames";
import { ReactNode } from "react";
import dismissedTipsStore from "store/dismissedTips.store";

type Props = {
  id: string;
  children: ReactNode;
  className?: string;
};

// Rosa, kompakt variant av Tips utan rubrik – "Visa inte igen" ligger
// inline i löptexten. Avfärdas permanent via dismissedTipsStore.
export const OperatorInlineTips = ({ id, children, className }: Props) => {
  const { dismissedTipsIds, addOne } = dismissedTipsStore();
  if (dismissedTipsIds.includes(id)) {
    return null;
  }
  return (
    <div
      className={cn(
        "flex items-start gap-x-2.5 rounded-xl bg-pink-50 px-4 py-3 ring-1 ring-inset ring-pink-100",
        className,
      )}
    >
      <LightBulbIcon
        className="mt-0.5 h-5 w-5 shrink-0 text-pink-400"
        aria-hidden="true"
      />
      <p className="text-sm text-pink-900">
        {children}{" "}
        <button
          type="button"
          onClick={() => addOne(id)}
          className="inline whitespace-nowrap font-semibold text-pink-800 underline underline-offset-2 transition-colors active:text-pink-900"
        >
          Visa inte igen
        </button>
      </p>
    </div>
  );
};
